// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--3kvH-","divider":"Footer-module--divider--qc20S"};